var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPhone = function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.016 4.502c.155 0 .328.02.482.06.31.04.591.12.855.24l.873 7.42a3.54 3.54 0 0 1-1.946.8c.536 1.88 1.428 3.56 2.619 4.96l.018.15.118.02a11.903 11.903 0 0 0 3.91 2.97c.127-.75.445-1.42.873-1.98l6.6 1.37c.12.38.201.77.21 1.2.018.12.018.24.018.36-.063 2.34-1.818 4.18-3.937 4.15h-.064a2.37 2.37 0 0 1-.39-.04c-8.166-.74-14.485-8.42-14.249-17.53.064-2.36 1.855-4.22 4.001-4.15h.01Z",
    stroke: "#0000B4"
  })));
};
export default SvgIconPhone;